/* REDCAMP PDP recommendation rails. Independent sections and native scrolling. */
(function () {
  'use strict';
  if (window.__redcampRecommendationRailsBound) return;
  window.__redcampRecommendationRailsBound = true;

  function cards(container) {
    return Array.prototype.filter.call(container.children, function (node) {
      return node.matches('.rc-rec-card[data-product-id]');
    });
  }

  function initRail(section) {
    if (!section) return;
    var rail = section.querySelector('.rc-rec-rail');
    var progress = section.querySelector('.rc-rec-progress');
    if (!rail || !progress) return;
    var thumb = progress.querySelector('.rc-rec-progress__thumb');
    var stage = section.querySelector('.rc-rec-stage');
    if (!thumb || !stage) return;
    var previous = stage.querySelector('[data-rc-scroll="prev"]');
    var next = stage.querySelector('[data-rc-scroll="next"]');

    // Size by the actual rail width: N complete cards + half of the next.
    // The related-products rail arrives asynchronously from Impulse.
    var track = rail.querySelector('.rc-rec-track');
    if (!track) return;
    function update() {
      var small = window.matchMedia('(max-width: 768px)').matches;
      var vars = getComputedStyle(section);
      var full = parseInt(vars.getPropertyValue(small ? '--rc-rec-mobile-full' : '--rc-rec-visible'), 10) || (small ? 2 : 5);
      var gap = parseFloat(getComputedStyle(track).columnGap) || (small ? 12 : 16);
      var width = rail.clientWidth;
      if (width > 0) {
        var cardWidth = Math.max(40, (width - full * gap) / (full + 0.5));
        // Only update when the viewport/card width actually changes.
        if (Math.abs((parseFloat(rail.style.getPropertyValue('--rc-rec-card-width')) || 0) - cardWidth) > 0.5) {
          rail.style.setProperty('--rc-rec-card-width', cardWidth + 'px');
          stage.style.setProperty('--rc-rec-nav-center', cardWidth / 2 + 'px');
        }
      }
      updateProgress(rail, progress, thumb);
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      stage.classList.toggle('rc-rec-stage--no-scroll', max <= 1);
      if (previous) previous.disabled = max <= 1 || rail.scrollLeft <= 1;
      if (next) next.disabled = max <= 1 || rail.scrollLeft >= max - 1;
    }
    if (rail.dataset.rcProgressAttached === 'yes') {
      update();
      return;
    }
    rail.dataset.rcProgressAttached = 'yes';

    // Continuous mouse dragging; native touch keeps mobile momentum scrolling.
    // Sample recent drag movement to avoid a fling after the pointer pauses.
    var drag = null;
    var suppressClick = false;
    var suppressTimer = null;
    var inertiaFrame = 0;
    var inertiaVelocity = 0;
    function stopInertia() {
      if (inertiaFrame) cancelAnimationFrame(inertiaFrame);
      inertiaFrame = 0;
      inertiaVelocity = 0;
    }
    function fling(velocity) {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || Math.abs(velocity) < .13) return;
      var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
      if (max < 1) return;
      var tau = Math.abs(velocity) >= 1.5 ? 620 : 390;
      inertiaVelocity = Math.max(-4.6, Math.min(4.6, velocity));
      var previousTime = performance.now();
      function animate(timestamp) {
        if (!rail.isConnected || drag) { stopInertia(); return; }
        var dt = Math.max(1, Math.min(40, timestamp - previousTime));
        previousTime = timestamp;
        var step = inertiaVelocity * tau * (1 - Math.exp(-dt / tau));
        var nextLeft = Math.max(0, Math.min(max, rail.scrollLeft + step));
        var oldLeft = rail.scrollLeft;
        rail.scrollLeft = nextLeft;
        inertiaVelocity *= Math.exp(-dt / tau);
        if (Math.abs(inertiaVelocity) < .035 || Math.abs(nextLeft - oldLeft) < .01) {
          stopInertia();
          update();
        } else inertiaFrame = requestAnimationFrame(animate);
      }
      inertiaFrame = requestAnimationFrame(animate);
    }
    rail.querySelectorAll('img').forEach(function (img) { img.draggable = false; });
    rail.addEventListener('dragstart', function (event) { event.preventDefault(); });
    rail.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0 || rail.scrollWidth <= rail.clientWidth + 1) return;
      stopInertia();
      if (suppressTimer) clearTimeout(suppressTimer);
      suppressClick = false;
      drag = {id:event.pointerId, x:event.clientX, lastX:event.clientX, time:performance.now(),
        scroll:rail.scrollLeft, moving:false, samples:[{x:rail.scrollLeft,t:performance.now()}]};
    });
    document.addEventListener('pointermove', function (event) {
      if (!drag || event.pointerId !== drag.id || !rail.isConnected) return;
      if (Math.abs(event.clientX - drag.x) > 5) drag.moving = true;
      if (!drag.moving) return;
      rail.classList.add('is-rc-dragging');
      event.preventDefault();
      // Incremental movement avoids jumps when the pointer changes speed.
      var delta = event.clientX - drag.lastX;
      drag.lastX = event.clientX;
      rail.scrollLeft -= delta;
      var t = performance.now();
      drag.time = t;
      drag.samples.push({x:rail.scrollLeft,t:t});
      drag.samples = drag.samples.filter(function (item) { return t - item.t <= 110; });
    }, {passive:false});
    function endDrag(event) {
      if (!drag || event.pointerId !== drag.id) return;
      var old = drag;
      drag = null;
      rail.classList.remove('is-rc-dragging');
      if (!old.moving) return;
      suppressClick = true;
      if (suppressTimer) clearTimeout(suppressTimer);
      suppressTimer = setTimeout(function () { suppressClick = false; }, 180);
      if (event.type === 'pointercancel' || performance.now() - old.time > 110) return;
      var latest = old.samples[old.samples.length - 1];
      var earliest = old.samples[0];
      if (latest && earliest && latest.t > earliest.t) {
        fling((latest.x - earliest.x) / (latest.t - earliest.t));
      }
    }
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
    rail.addEventListener('click', function (event) {
      if (suppressClick) { event.preventDefault(); event.stopImmediatePropagation(); suppressClick = false; }
    }, true);
    rail.addEventListener('wheel', stopInertia, {passive:true});
    rail.addEventListener('touchstart', stopInertia, {passive:true});
    [previous, next].forEach(function (button) {
      if (!button) return;
      button.addEventListener('click', function () {
        stopInertia();
        var direction = button === next ? 1 : -1;
        var distance = Math.max(rail.clientWidth * .75, 90) * direction;
        rail.scrollBy({left:distance,behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto':'smooth'});
      });
    });

    rail.addEventListener('scroll', update, {passive:true});
    if (window.ResizeObserver) {
      var observer = new ResizeObserver(update);
      observer.observe(rail);
      observer.observe(track);
    }
    window.addEventListener('resize', update);
    progress.addEventListener('pointerdown', function (event) {
      if (progress.hidden || event.button > 0) return;
      stopInertia();
      event.preventDefault();
      progress.setPointerCapture && progress.setPointerCapture(event.pointerId);
      scrollFromPointer(event, rail, progress);
    });
    progress.addEventListener('pointermove', function (event) {
      if (progress.hasPointerCapture && progress.hasPointerCapture(event.pointerId)) {
        scrollFromPointer(event, rail, progress);
      }
    });
    progress.addEventListener('pointerup', function (event) {
      if (progress.hasPointerCapture && progress.hasPointerCapture(event.pointerId)) progress.releasePointerCapture(event.pointerId);
    });
    update();
    // Lazy images and theme editor redraws can change the intrinsic width.
    requestAnimationFrame(update);
  }

  function updateProgress(rail, progress, thumb) {
    var width = rail.clientWidth;
    var content = rail.scrollWidth;
    var maximum = Math.max(0, content - width);
    progress.hidden = !width || maximum <= 1;
    var fraction = content > 0 ? Math.min(1, width / content) : 1;
    var size = progress.clientWidth * fraction;
    var available = Math.max(0, progress.clientWidth - size);
    thumb.style.width = (fraction * 100) + '%';
    thumb.style.transform = 'translateX(' + (maximum ? available * Math.max(0, rail.scrollLeft) / maximum : 0) + 'px)';
  }

  function scrollFromPointer(event, rail, progress) {
    var bounds = progress.getBoundingClientRect();
    var x = Math.min(bounds.width, Math.max(0, event.clientX - bounds.left));
    var fraction = bounds.width ? x / bounds.width : 0;
    rail.scrollLeft = Math.max(0, rail.scrollWidth - rail.clientWidth) * fraction;
  }

  function initBestSellers(section) {
    if (!section || section.dataset.rcStarted === 'yes') return;
    section.dataset.rcStarted = 'yes';
    var grid = section.querySelector('[data-rc-bestsellers-grid]');
    if (!grid) return;
    var source = section.getAttribute('data-feed-url') || '';
    var limit = Math.max(1, parseInt(section.dataset.limit || '12', 10));
    var currentId = section.dataset.currentProductId;
    var excluded = new Set((section.dataset.excluded || '').split(',').filter(Boolean));
    var used = new Set();

    // Apply the same constraints to manual pins and automatic products.
    cards(grid).forEach(function (card) {
      var id = card.dataset.productId;
      if (!id || id === currentId || excluded.has(id) || used.has(id) || used.size >= limit) {
        card.remove();
      } else { used.add(id); }
    });
    initRail(section);
    if (!source || used.size >= limit) {
      section.hidden = used.size === 0;
      return;
    }
    var url;
    try {
      url = new URL(source, window.location.href);
      if (url.origin !== location.origin) throw new Error('Invalid collection origin');
      url.searchParams.set('sort_by', 'best-selling');
      url.searchParams.set('section_id', 'redcamp-bestsellers-feed');
    } catch (_error) {
      section.hidden = used.size === 0;
      return;
    }

    fetch(url.toString(), {credentials:'same-origin'}).then(function (response) {
      if (!response.ok) throw new Error('Collection request unavailable');
      return response.text();
    }).then(function (html) {
      if (!section.isConnected) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var feed = parsed.querySelector('.rc-bestsellers-feed');
      if (!feed || feed.getAttribute('data-rc-feed-sort') !== 'best-selling') return;
      var items = feed.querySelector('.rc-bestsellers-feed__items');
      if (!items) return;
      cards(items).forEach(function (item) {
        if (used.size >= limit) return;
        var id = item.dataset.productId;
        if (!id || id === currentId || used.has(id) || excluded.has(id)) return;
        used.add(id);
        grid.appendChild(document.importNode(item, true));
      });
      section.hidden = used.size === 0;
      normalizeRecommendationRatings(section);
      initRail(section);
      document.dispatchEvent(new CustomEvent('redcamp:recommendations:updated', {detail:{section:section}}));
    }).catch(function () {
      // Existing manual pins remain visible if the collection feed is unavailable.
      section.hidden = used.size === 0;
    });
  }

  function normalizeRecommendationRatings(scope) {
    if (!scope || !scope.querySelectorAll) return;
    scope.querySelectorAll('.rc-rec-card__rating .jdgm-prev-badge').forEach(function (badge) {
      var rawCount = badge.getAttribute('data-number-of-reviews');
      var text = badge.querySelector('.jdgm-prev-badge__text');
      // Judge.me fills the badge asynchronously on some pages.
      if (rawCount == null && text) {
        var found = (text.textContent || '').match(/\d[\d,]*/);
        if (found) rawCount = found[0].replace(/,/g, '');
      }
      var number = rawCount == null ? NaN : Number(rawCount);
      if (!Number.isFinite(number) || number < 0) return;
      var formatted = '(' + number + ')';
      if (!text) {
        text = document.createElement('span');
        text.className = 'jdgm-prev-badge__text';
        badge.appendChild(text);
      }
      if (text.textContent !== formatted) text.textContent = formatted;
    });
  }

  // Observe only these two product rows. Judge.me may update badge HTML later.
  function watchRecommendationRatings(section) {
    if (section.dataset.rcRatingWatcher === 'yes') return;
    section.dataset.rcRatingWatcher = 'yes';
    var observer = new MutationObserver(function (records) {
      if (records.some(function (record) { return record.type === 'childList'; })) {
        normalizeRecommendationRatings(section);
      }
    });
    observer.observe(section, {subtree:true, childList:true});
    normalizeRecommendationRatings(section);
  }

  function init(scope) {
    var target = scope && scope.querySelectorAll ? scope : document;
    var allRows = target.matches && target.matches('.rc-rec-section') ? [target] : target.querySelectorAll('.rc-rec-section');
    Array.prototype.forEach.call(allRows, watchRecommendationRatings);
    if (target.matches && target.matches('[data-rc-bestsellers]')) initBestSellers(target);
    target.querySelectorAll('[data-rc-bestsellers]').forEach(initBestSellers);
    var related = target.matches && target.matches('.rc-rec-section') ? [target] : target.querySelectorAll('.rc-rec-related');
    Array.prototype.forEach.call(related, initRail);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); }, {once:true});
  else init(document);
  document.addEventListener('recommendations:loaded', function (event) {
    var related = event.detail && event.detail.section;
    if (related) { init(related); requestAnimationFrame(function () { normalizeRecommendationRatings(related); }); }
  });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
